import React from 'react';
import ChangeCompassDashboard from '../components/changeCompass/ChangeCompassDashboard';

const ChangeCompass = () => {
  return (
    <div className="change-compass-page">
      <ChangeCompassDashboard />
    </div>
  );
};

export default ChangeCompass; 